import { TranslationService } from "@/core/services/TranslationService";
import { IUserResetPassword } from "@/interfaces/iUser";
import UserSite from "@/views/user/views/UserSite.vue";
import UserForm from "@/views/user/views/UserForm.vue";
import UserActivity from "@/views/user/views/UserActivity.vue";
import UserDetail from "@/views/user/views/UserDetail.vue";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";
import { boolean } from "yup";
export function userTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.firstName"),
      key: "firstName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.lastName"),
      key: "lastName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.email"),
      key: "email",
    },
    {
      name: TranslationService.translate("pages.user.phoneNumber"),
      key: "phoneNumber",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.sites"),
      key: "site",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: "",
      key: "clone",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function userPermissionsUserRoleTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "userSites/delete",
    entityLabel: TranslationService.translate("common.siteUserRole"),
  };
}
export function userCustomPermissionsBulkDelete() {
  return {
    showDelete: true,
    key: "permissions",
    entity: "userPermissions",
    entityLabel: TranslationService.translate("pages.user.customPermissons"),
  };
}

export function userPermissionsCustomPermissionsTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "userSites",
    entityLabel: TranslationService.translate("common.users"),
  };
}

export function userTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "userAccounts",
    entityLabel: TranslationService.translate("common.users"),
  };
}
export function userTableBulkUpdate() {
  return {
    showUpdate: true,
    key: "webId",
    entity: "userAccounts",
    entityLabel: TranslationService.translate("common.users"),
  };
}

export function userRoleTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.user.role"),
      key: "roleCodeText",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.createdDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.updateDate"),
      key: "updateDate",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function userSiteTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "userSites",
    entityLabel: TranslationService.translate("pages.form.sites"),
  };
}

export function userCustomPermissionTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "userPermissions",
    entityLabel: TranslationService.translate("pages.form.sites"),
  };
}

export function userFormTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "formUsers",
    entityLabel: TranslationService.translate("forms"),
  };
}

export function userPermissionTableHeaders() {
  return [
    {
      name: TranslationService.translate("title"),
      key: "title",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.user.permission.groupCode"),
      key: "groupCode",
    },
    {
      name: TranslationService.translate(
        "pages.user.permission.permissionCode"
      ),
      key: "permissionCode",
    },
    {
      name: TranslationService.translate("common.createdDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.updateDate"),
      key: "updateDate",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
    },
  ];
}
export function userSiteTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.siteNumber"),
      key: "code",
    },
    {
      name: TranslationService.translate("pages.site.siteName"),
      key: "siteName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.role"),
      key: "roleName",
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}
export function permissionsTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.site.siteName"),
      key: "siteName",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.site.siteNumber"),
      key: "code",
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "createdDate",
    },
  ];
}
export function userFormTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.user.formName"),
      key: "name",
      sortable: true,
      sortingField: "formDefinition.name",
    },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function userPermissionUserRoleTableHeaders() {
  return [
    // {
    //   name: TranslationService.translate("common.user"),
    //   key: "name",
    //   sortingField: "firstName",
    // },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.site.role"),
      key: "userRoleName",
      sortable: true,
      sortingField: "roleName",
    },
    {
      name: TranslationService.translate("common.assignedDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.assignedBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function userPermissionUserPermissionTableHeaders() {
  return [
    // {
    //   name: TranslationService.translate("common.user"),
    //   key: "firstName",
    //   sortingField: "first_name",
    // },
    // {
    //   name: TranslationService.translate("pages.site.role"),
    //   key: "roleName",
    //   sortingField: "role_name",
    // },
    // {
    //   name: TranslationService.translate("pages.site.site"),
    //   key: "siteName",
    //   sortingField: "site_name",
    // },
    {
      name: TranslationService.translate("pages.user.permissionName"),
      key: "title",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.read"),
      key: "read",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.create"),
      key: "create",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.update"),
      key: "update",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: TranslationService.translate("common.delete"),
      key: "delete",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function userPermissionCustomPermissionTableHeaders() {
  return [
    // {
    //   name: TranslationService.translate("common.user"),
    //   key: "firstName",
    //   sortingField: "first_name",
    // },
    {
      name: TranslationService.translate("common.siteName"),
      key: "siteName",
      sortingField: "site_name",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.user.permissionName"),
      key: "title",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.read"),
      key: "read",
    },
    {
      name: TranslationService.translate("common.create"),
      key: "create",
    },
    {
      name: TranslationService.translate("common.update"),
      key: "update",
    },
    {
      name: TranslationService.translate("common.delete"),
      key: "delete",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function userPermissionUserRoleTableFilters() {
  return [
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "siteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "roleIds",
      label: TranslationService.translate("common.roles"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/ROLES",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function userPermissionUserPermissionTableFilters() {
  return [
    {
      key: "permissions",
      label: TranslationService.translate("pages.user.permissions"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/PERMISSIONS",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function userPermissionCustomPermissionTableFilters() {
  return [
    {
      key: "permissions",
      label: TranslationService.translate("pages.user.permissions"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/PERMISSIONS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "filterSiteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
  ];
}

export function userTableFilters() {
  return [
    {
      key: "filterUserIds",
      label: TranslationService.translate("pages.user.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "filterSiteIds",
      label: TranslationService.translate("common.sites"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "site/filter/SITES",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
  ];
}

export function userActivityTableHeaders() {
  return [
    {
      name: TranslationService.translate("common.dateTime"),
      key: "createdDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.user"),
      key: "createdBy",
      sortable: true,
    },
    // {
    //   name: TranslationService.translate("common.type"),
    //   key: "typeCodeText",
    //   sortable: false,
    // },
    {
      name: TranslationService.translate("common.event"),
      key: "descriptions",
      sortable: false,
      attrs: {
        class: "vz-dataTable-left",
      },
    },
  ];
}

export function userActivityTableFilters(): IDataTableFilterOption[] {
  return [
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "userIds",
      label: TranslationService.translate("pages.user.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    // {
    //   key: "type",
    //   label: TranslationService.translate("common.type"),
    //   type: "lookup",
    //   attrs: {
    //     mode: "tags",
    //   },
    //   url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKAuditType",
    //   textKey: "text",
    //   valueKey: "value",
    // },
  ];
}

export const USER_SITE_LOOKUP = {
  url: "site/filter/SITES",
  textKey: "text",
  valueKey: "value",
};

export const USER_FORM_LOOKUP = {
  url: "forms/filter/FORM_NAME",
  textKey: "text",
  valueKey: "value",
};
//
export const USER_ROLE_LOOKUP = {
  url: "security/filter/ROLES",
  textKey: "text",
  valueKey: "value",
};
export const USER_LANGUAGE_LOOKUP = {
  url: "static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKLanguage",
  textKey: "text",
  valueKey: "value",
};
export const RESET_PASSWORD_CONFIG: IUserResetPassword = {
  email: "",
  startDate: new Date().toISOString().slice(0, 10),
  externalKey: "",
  fromEmail: "solelogiqtest@gmail.com",
  fromName: "Solelogiq",
  sendAttempts: "1",
  permanentFailure: "false",
  emailRecipientModel: [
    {
      smtpStatusCode: "123",
      recipientType: "TO",
    },
  ],
};

export function USER_TABS() {
  return [
    {
      title: TranslationService.translate("common.detail"),
      name: "user.detail",
      icon: "bi bi-card-text me-2 fs-4 text-primary",
      component: UserDetail,
      props: {
        data: {},
      },
    },
    {
      title: TranslationService.translate("pages.user.userSite"),
      name: "user.site",
      icon: "bi bi-diagram-3 me-2 fs-4 text-primary",
      component: UserSite,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("pages.user.userFrom"),
      name: "user.form",
      icon: "bi bi-layers me-2 fs-1 text-primary align-middle mb-1",
      component: UserForm,
      props: {
        data: {},
        openDrawer: boolean,
      },
    },
    {
      title: TranslationService.translate("common.activity"),
      name: "user.activity",
      icon: "bi bi-signpost-2 me-2 fs-4 text-primary",
      component: UserActivity,
      props: {
        data: {},
      },
    },
  ];
}
